<template>
  <!-- 头部 导航栏-->
  <div id = "views">
    <transition name="fadesd" mode="out-in">
      <router-view/>
    </transition>
    <!-- <div id="vanloading" v-if="$store.state.loading">
      <van-loading class="vanloading-icon" color="black" />
      <p class="lang-toast__content">数据加载中</p>
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue'
import { List, Icon, NavBar, Toast, Loading } from 'vant'
Vue.use(List).use(Icon).use(NavBar).use(Toast).use(Loading)
export default {
  name: 'views',
}
</script>

<style scoped>
  #vanloading{
    position: fixed;
    z-index: 999;
    top: 50%;
    left: 50%;
    width: 80px;
    height: 80px;
    margin-top: -40px;
    margin-left: -40px;
    background: rgba(17,17,17,0.7);
    text-align: center;
    border-radius: 5px;
    color: #FFFFFF;
    font-size: 12px;
  }
  #vanloading .vanloading-icon {
    margin: 5px auto;
  }
  #views {
    height: 100%;
  }
</style>
<style>
  #header .van-icon {
    color: #fff !important;
  }
  #header .van-nav-bar__left{
    font-size: 18px;
  }
  .amap-logo, .amap-copyright {
    visibility: hidden !important;
  }
  .fadesd-enter-active, .fadesd-leave-active {
    transition: all .2s ease;
  }
  .fadesd-enter, .fadesd-leave-active {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/views.vue